import { IMenuItem, IApplicationMenuItem, IAccountMenuItem } from 'src/types/module_types_menu';
import { getActiveRoute } from 'src/core/settings';
import { Hosting } from 'src/core/ahp';

import type { IView } from'../../../pip/library/pi-interop/pi-interop.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

type TSecondaryMenu = {
  application: IApplicationMenuItem[];
  account: IAccountMenuItem[];
};

// REPLACE (hip-ts)
interface ITertiaryNavigationNavigationItems extends HTMLElement {
  navigationActions: IMenuItem[];
}

// REPLACE (hip-ts)
declare global {
  interface Window {
    ['HIP']: any;
  }
}

export class TertiaryMenuViewRC implements IView {
  id = 'tertiary-menu';
  ns = 'ahp';

  region: HTMLElement;

  __activeRoute: string;
  __secondaryNavigationItems: IMenuItem[];
  constructor(public ahp: Hosting) {}

  mount(region: HTMLElement) {
    const navEl = document.createElement('hi-navigation-tertiary');

    navEl['navigationActions'] = this.__calculateTertiaryNavigationResources();

    navEl.addEventListener('opened-changed', (e: CustomEvent) => {
      const ownerEl = f1.safe({}, f1.read('/0', [], document.querySelectorAll('[x-shell="owner"]')));

      if (ownerEl) {
        window.HIP.util.toggleAttribute(ownerEl, 'x-menu-state', e.detail.value, 'opened');
      }
    });

    region.appendChild(navEl);
    return Promise.resolve(this);
  }

  stateChange() {
    const navEls: HTMLElement[] = (document.querySelectorAll('hi-navigation-tertiary') as unknown) as HTMLElement[];
    const navEl: ITertiaryNavigationNavigationItems = navEls[0] as ITertiaryNavigationNavigationItems;

    if (navEl !== null) {
      navEl.navigationActions = this.__calculateTertiaryNavigationResources();
    }

    this.__activeRoute = getActiveRoute();

    const activeElementIndex = this.__getActiveRouteIndex(this.__secondaryNavigationItems, this.__activeRoute);
    const children = navEl.querySelectorAll('li');

    children.forEach((child, index) => {
      window.HIP.util.toggleAttribute(child, 'active', activeElementIndex === index, 'active');
    });

    if (activeElementIndex > 0) {
      const linkEle = navEl.querySelector(`#hi-nav-tertiary-link-${activeElementIndex}`) as HTMLElement;
      linkEle.focus();
    }

    return Promise.resolve(this);
  }

  private __getActiveRouteIndex(routingItems: IMenuItem[], activeRoute: string) {
    return routingItems.findIndex((navResource) => navResource.uri.substring(1) === activeRoute);
  }

  private __calculateTertiaryNavigationResources() {
    const MenuAHP = this.ahp.menu;
    const defaultMenus: TSecondaryMenu = {
      application: [],
      account: []
    };

    const { application }: TSecondaryMenu =
      f1.read('/menu/navigation_items', defaultMenus, MenuAHP) ||
      f1.read('/menu/navigation_menus', defaultMenus, MenuAHP);

    this.__activeRoute = getActiveRoute();

    const primaryActive = MenuAHP.getActiveResource(application, this.__activeRoute) || {};
    const primaryNavigationItems: IMenuItem[] = primaryActive.navigation_items || primaryActive.children || [];

    const secondaryActive = MenuAHP.getActiveResource(primaryNavigationItems, this.__activeRoute) || {};
    this.__secondaryNavigationItems = secondaryActive.navigation_items || secondaryActive.children || [];

    const relativeSecondaryNavigationItems = f1.each((navigationItem) => {
      navigationItem.uri = MenuAHP.normalizeURI(navigationItem.uri);
    }, this.__secondaryNavigationItems) as IMenuItem[];

    return f1.filter((item) => !item.hidden, relativeSecondaryNavigationItems);
  }
}
